<h1 mat-dialog-title class="mat-dialog-title">
    Description des droits et leurs rôles
</h1>
<div mat-dialog-content>
    <div *ngIf="dataCount === 0">
        Aucun rôle
    </div>
    <mat-table *ngIf="dataCount > 0" #table [dataSource]="dataSource">

        <!--ID-->
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>
                Rôle
            </mat-header-cell>
            <mat-cell *matCellDef="let element" fxLayout="row" fxLayoutGap="20px">
                <span>{{ element.id }}</span>
                <mat-icon *ngIf="element.description" [matTooltip]="element.description" matTooltipClass="syntooltip" svgIcon="information-outline"></mat-icon>
            </mat-cell>
        </ng-container>

        <!--READ-->
        <ng-container matColumnDef="READ">
            <mat-header-cell *matHeaderCellDef>
                Lecture seule
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <mat-chip-listbox>
                    <mat-chip disableRipple disableRipple="true" *ngFor="let acl of aclList(element.acl, 'READ')">{{ acl }}</mat-chip>
                </mat-chip-listbox>
            </mat-cell>
        </ng-container>

        <!--EDIT-->
        <ng-container matColumnDef="EDIT">
            <mat-header-cell *matHeaderCellDef>
                Lecture/écriture
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <mat-chip-listbox>
                    <mat-chip disableRipple *ngFor="let acl of aclList(element.acl, 'EDIT')">{{ acl }}</mat-chip>
                </mat-chip-listbox>
            </mat-cell>
        </ng-container>

        <!--ADMIN-->
        <ng-container matColumnDef="ADMIN">
            <mat-header-cell *matHeaderCellDef>
                Administration
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <mat-chip-listbox>
                    <mat-chip disableRipple *ngFor="let acl of aclList(element.acl, 'ADMIN')">{{ acl }}</mat-chip>
                </mat-chip-listbox>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fermer</button>
</div>
